export default __webpack_public_path__ + "static/media/chat-with-mentor.16944486.svg";